import React from 'react';
import { useCurrencyFormatter } from '../../hooks/useCurrencyFormatter';

type Props = {
  value: number;
  currency: string;
};

const FormattedCurrency: React.FC<React.PropsWithChildren<Props>> = ({
  value,
  currency,
}) => {
  const formatCurrency = useCurrencyFormatter();

  return <>{formatCurrency({ value, currency })}</>;
};

export default FormattedCurrency;
